<template>
  <form class=" vr360-auth__authorization" @submit.prevent="handlerLogin">
    <h1 class="vr360-head-h1 vr360-auth-main__title">Authorization</h1>

    <input-text :placeholder="'Your Email'"
                :type="'email'"
                :isCentered="true"
                v-model="user.email"/>

    <input-text :placeholder="'Password'"
                :type="'password'"
                :isCentered="true"
                v-model="user.password"/>

    <button class="vr360-btn" type="submit">
      <span>Login</span>
    </button>
    <!-- <a href="#" class="vr360-text-caption vr360-text-blue vr360-text-upper vr360-link">Forgot password?</a> -->
  </form>
</template>

<script>
import { mapActions } from "vuex";
import InputText from "../partials/InputText";

export default {
  name: "Login",
  components: {
    InputText
  },
  data() {
    return {
      user: {
        email: "test@email.com",
        password: "somepass"
        // email: "",
        // password: ""
      }
    };
  },
  methods: {
    ...mapActions({
      loginUser: "user/loginUser"
    }),
    handlerLogin() {
      this.loginUser({ email: this.user.email, password: this.user.password });
    }
  }
};
</script>
